module.exports = __webpack_public_path__ + "img/arrow_right_blue.f9bffe96.svg";